import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import QRScanner from "./Pages/QRScanner/QRScanner";
import ResultPage from "./Pages/ResultPage/ResultPage";
import HomeLayout from "./Layout/HomeLayout";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeLayout page={<Home/>}/> }/> 
        <Route path="/scanner" element={<HomeLayout page={<QRScanner/>}/> }/> 
        <Route path="/result" element={<HomeLayout page={<ResultPage/>}/> }/> 
      </Routes>
    </Router>
  );
}

export default App;
